import { useEffect } from 'react';
import { useUrlLocale } from '../i18n/url-locale';
import { getSettings } from './content';
import { documentTitle } from './seo';

/**
 * Keeps `document.title` right after client-side navigation. The prerendered
 * HTML already carries the correct title for the first page load.
 */
export function usePageTitle(path: string, title: string): void {
  const locale = useUrlLocale();
  useEffect(() => {
    document.title = documentTitle({ path, title }, getSettings(locale).siteName);
  }, [locale, path, title]);
}
